// src/data/data.js

// This array holds all the game data for your website.
// Keeping it in a separate file helps keep your page components clean.
export const games = [
  // --- Mahjong Games ---
  {
    id: 1,
    title: "Free Aliens",
    genre: "Mahjong",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/freealiens800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/3AVsNPnOim4?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=3AVsNPnOim4",
    embedLink: "https://cdn.htmlgames.com/FreeAliens/",
    year: 2016,
    rating: 11,
    price: 11.11,
    originalPrice: 12.34,
    discount: "10%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/freealiens800450.webp",
    isFree: true,
    genres: "Mahjong",
    platform: "PC",
    publisher: "Playverse",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 2,
    title: "Delicious Duos",
    genre: "Mahjong",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/deliciousduos800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/g6f9Mu9Z2Cw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=g6f9Mu9Z2Cw",
    embedLink: "https://cdn.htmlgames.com/DeliciousDuos/",
    year: 2000,
    rating: 58,
    price: 39.77,
    originalPrice: 49.71,
    discount: "20%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/deliciousduos800450.webp",
    isFree: true,
    genres: "Mahjong",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 3,
    title: "Mahjongg Pyramids",
    genre: "Mahjong",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/mahjonggpyramids800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/ntkY4StwmMg?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=ntkY4StwmMg",
    embedLink: "https://cdn.htmlgames.com/MahjonggPyramids/",
    year: 2006,
    rating: 35,
    price: 4.03,
    originalPrice: 10.08,
    discount: "60%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/mahjonggpyramids800450.webp",
    isFree: true,
    genres: "Mahjong",
    platform: "PC",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 4,
    title: "Mahjong Merge",
    genre: "Mahjong",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/mahjongmerge800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/RPwA49RsRN4?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=RPwA49RsRN4",
    embedLink: "https://cdn.htmlgames.com/MahjongMerge/",
    year: 2000,
    rating: 73,
    price: 27.16,
    originalPrice: 30.18,
    discount: "10%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/mahjongmerge800450.webp",
    isFree: true,
    genres: "Mahjong",
    platform: "PC",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 5,
    title: "Christmas Connect",
    genre: "Mahjong",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/christmasconnect800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/3ACqExQ_ASo?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=3ACqExQ_ASo",
    embedLink: "https://cdn.htmlgames.com/ChristmasConnect/",
    year: 2001,
    rating: 79,
    price: 2.74,
    originalPrice: 9.14,
    discount: "70%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/christmasconnect-800450.webp",
    isFree: true,
    genres: "Mahjong",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },

  // --- Solitaire Games ---
  {
    id: 6,
    title: "Yukon Freecell",
    genre: "Solitaire",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/yukonfreecell800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/9xfIN9FSfe0?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=9xfIN9FSfe0",
    embedLink: "https://cdn.htmlgames.com/YukonFreecell/",
    year: 2013,
    rating: 97,
    price: 9.25,
    originalPrice: 30.83,
    discount: "70%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/yukonfreecell800450.webp",
    isFree: true,
    genres: "Solitaire",
    platform: "Web Browser",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 7,
    title: "Spider Solitaire 2 Suits",
    genre: "Solitaire",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/spidersolitaire2suits800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/Nj2nWjxdvtk?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=Nj2nWjxdvtk",
    embedLink: "https://cdn.htmlgames.com/SpiderSolitaire2Suits/",
    year: 2022,
    rating: 53,
    price: 19.38,
    originalPrice: 24.22,
    discount: "20%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/spidersolitaire2suits800450.webp",
    isFree: true,
    genres: "Solitaire",
    platform: "Web Browser",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 8,
    title: "Spider Freecell",
    genre: "Solitaire",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/spiderfreecell800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/X-JZPhMgnPI?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=X-JZPhMgnPI",
    embedLink: "https://cdn.htmlgames.com/SpiderFreecell/",
    year: 2000,
    rating: 13,
    price: 13.35,
    originalPrice: 26.69,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/spiderfreecell800450.webp",
    isFree: true,
    genres: "Solitaire",
    platform: "All Platforms",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 9,
    title: "Gargantua Double Klondike",
    genre: "Solitaire",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/gargantuadoubleklondike800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/ejWUNIUk774?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=ejWUNIUk774",
    embedLink: "https://cdn.htmlgames.com/GargantuaDoubleKlondike/",
    year: 2020,
    rating: 85,
    price: 17.02,
    originalPrice: 42.55,
    discount: "60%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/gargantuadoubleklondike800450.webp",
    isFree: true,
    genres: "Solitaire",
    platform: "Web Browser",
    publisher: "Playverse",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 10,
    title: "Flower Solitaire",
    genre: "Solitaire",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/flowersolitaire800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/1l8z4Qv8x18?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=1l8z4Qv8x18",
    embedLink: "https://cdn.htmlgames.com/FlowerSolitaire/",
    year: 2019,
    rating: 58,
    price: 25.42,
    originalPrice: 36.31,
    discount: "30%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/flowersolitaire-800450.webp",
    isFree: true,
    genres: "Solitaire",
    platform: "PC",
    publisher: "Playverse",
    players: "Multiplayer",
    isOnline: true,
  },

  // --- Action Games ---
  
  {
    id: 11,
    title: "Red and Green 2",
    genre: "Action",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/WAiml6iAPw8?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=WAiml6iAPw8",
    embedLink: "https://cdn.htmlgames.com/RedAndGreen2/",
    year: 2014,
    rating: 15,
    price: 5.89,
    originalPrice: 29.47,
    discount: "80%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen2800450.webp",
    isFree: true,
    genres: "Action",
    platform: "All Platforms",
    publisher: "Skyplay",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 12,
    title: "Bottle Shooter",
    genre: "Action",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/bottleshooter800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/Wpk6XZW-X18?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=Wpk6XZW-X18",
    embedLink: "https://cdn.htmlgames.com/BottleShooter/",
    year: 2023,
    rating: 52,
    price: 3.62,
    originalPrice: 5.17,
    discount: "30%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/bottleshooter800450.webp",
    isFree: true,
    genres: "Action",
    platform: "PC",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 13,
    title: "Traffic Control",
    genre: "Action",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficcontrol800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/pvnN9fA-61A?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=pvnN9fA-61A",
    embedLink: "https://cdn.htmlgames.com/TrafficControl/",
    year: 2005,
    rating: 46,
    price: 19.8,
    originalPrice: 39.61,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficcontrol800450.webp",
    isFree: true,
    genres: "Action",
    platform: "PC",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 14,
    title: "Jungle Jump",
    genre: "Action",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/junglejump800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/n0fqpwvBenI?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=n0fqpwvBenI",
    embedLink: "https://cdn.htmlgames.com/JungleJump/",
    year: 2012,
    rating: 88,
    price: 30.66,
    originalPrice: 38.33,
    discount: "20%",
    image: "https://www.htmlgames.com/uploaded/game/thumb800/junglejump300.webp",
    isFree: true,
    genres: "Action",
    platform: "Web Browser",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 15,
    title: "Neon Factory",
    genre: "Action",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/neonfactory800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/n-9ISKxpdQM?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=n-9ISKxpdQM",
    embedLink: "https://cdn.htmlgames.com/NeonFactory/",
    year: 2008,
    rating: 42,
    price: 17.62,
    originalPrice: 29.36,
    discount: "40%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/neonfactory800450.webp",
    isFree: true,
    genres: "Action",
    platform: "Mobile",
    publisher: "Playverse",
    players: "Single Player",
    isOnline: true,
  },

  // --- Match 3 Games ---
  {
    id: 16,
    title: "Bubble Shooter",
    genre: "Match 3",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/bubble_shooter800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/dTJ5IBX-BkM?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=dTJ5IBX-BkM",
    embedLink: "https://cdn.htmlgames.com/BubbleShooter/",
    year: 2011,
    rating: 65,
    price: 8.69,
    originalPrice: 17.38,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/bubble_shooter800450.webp",
    isFree: true,
    genres: "Match 3",
    platform: "Mobile",
    publisher: "HTML Games Studio",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 17,
    title: "Connect the Bubbles",
    genre: "Match 3",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/connect-the-bubbles-800x450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/Alct2yho-Fk?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=Alct2yho-Fk",
    embedLink: "https://cdn.htmlgames.com/ConnectTheBubbles/",
    year: 2009,
    rating: 45,
    price: 7.91,
    originalPrice: 15.81,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/connect-the-bubbles-300.webp",
    isFree: true,
    genres: "Match 3",
    platform: "PC",
    publisher: "FunArcade",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 18,
    title: "Love Bubbles",
    genre: "Match 3",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/lovebubbles800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/v__ZhwLkVIw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=v__ZhwLkVIw",
    embedLink: "https://cdn.htmlgames.com/LoveBubbles/",
    year: 2017,
    rating: 70,
    price: 13.3,
    originalPrice: 33.24,
    discount: "60%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/lovebubbles800450.webp",
    isFree: true,
    genres: "Match 3",
    platform: "PC",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 19,
    title: "Jewels of the Medici",
    genre: "Match 3",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/jewelsofthemedici800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/55fvVkyvjNw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=55fvVkyvjNw",
    embedLink: "https://cdn.htmlgames.com/JewelsOfTheMedici/",
    year: 2014,
    rating: 86,
    price: 2.85,
    originalPrice: 28.51,
    discount: "90%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/jewelsofthemedici800450.webp",
    isFree: true,
    genres: "Match 3",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 20,
    title: "Christmas Match 3",
    genre: "Match 3",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/christmasmatch3800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/91qwOrWp038?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=91qwOrWp038",
    embedLink: "https://cdn.htmlgames.com/ChristmasMatch3/",
    year: 2004,
    rating: 52,
    price: 4.12,
    originalPrice: 41.24,
    discount: "90%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/christmasmatch3800450.webp",
    isFree: true,
    genres: "Match 3",
    platform: "PC",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },

  // --- Mind Games ---
  {
    id: 21,
    title: "Find the Odd One Out",
    genre: "Mind",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/findtheoddout800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/uBeuPlyZ0As?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=uBeuPlyZ0As",
    embedLink: "https://cdn.htmlgames.com/FindTheOddOneOut/",
    year: 2012,
    rating: 94,
    price: 8.63,
    originalPrice: 21.57,
    discount: "60%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/findtheoddout800450.webp",
    isFree: true,
    genres: "Mind",
    platform: "Web Browser",
    publisher: "Playverse",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 22,
    title: "Sudoku Classic",
    genre: "Mind",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/sudokuclassic800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/YgJqAKYwW8E?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=YgJqAKYwW8E",
    embedLink: "https://cdn.htmlgames.com/SudokuClassic/",
    year: 2007,
    rating: 25,
    price: 13.18,
    originalPrice: 26.35,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/sudokuclassic800450.webp",
    isFree: true,
    genres: "Mind",
    platform: "PC",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 23,
    title: "Nonogram Saga",
    genre: "Mind",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/nonogramsaga800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/PZAUgXyJbCE?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=PZAUgXyJbCE",
    embedLink: "https://cdn.htmlgames.com/NonogramSaga/",
    year: 2009,
    rating: 67,
    price: 39.61,
    originalPrice: 49.51,
    discount: "20%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/nonogramsaga800450.webp",
    isFree: true,
    genres: "Mind",
    platform: "PC",
    publisher: "FunArcade",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 24,
    title: "1010 Halloween",
    genre: "Mind",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/1010halloween800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/H8jEo1PpJxk?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=H8jEo1PpJxk",
    embedLink: "https://cdn.htmlgames.com/1010Halloween/",
    year: 2017,
    rating: 83,
    price: 13.36,
    originalPrice: 33.41,
    discount: "60%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/1010halloween800450.webp",
    isFree: true,
    genres: "Mind",
    platform: "PC",
    publisher: "FunArcade",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 25,
    title: "Number Merge",
    genre: "Mind",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/numbermerge800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/0LtWuK7fCMI?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=0LtWuK7fCMI",
    embedLink: "https://cdn.htmlgames.com/NumberMerge/",
    year: 2017,
    rating: 49,
    price: 8.9,
    originalPrice: 11.12,
    discount: "20%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/numbermerge800450.webp",
    isFree: true,
    genres: "Mind",
    platform: "Web Browser",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },

  // --- Classic ---
  {
    id: 26,
    title: "One Line",
    genre: "Classic",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/oneline800x450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/G_wPpS6S16w?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=G_wPpS6S16w",
    embedLink: "https://cdn.htmlgames.com/OneLine/",
    year: 2020,
    rating: 69,
    price: 22.71,
    originalPrice: 28.39,
    discount: "20%",
    image: "https://www.htmlgames.com/uploaded/game/thumb800/oneline800450.webp",
    isFree: true,
    genres: "Classic",
    platform: "All Platforms",
    publisher: "Playverse",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 27,
    title: "Carrom Pool",
    genre: "Classic",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/carrompool800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/tPO8otIb1DQ?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=tPO8otIb1DQ",
    embedLink: "https://cdn.htmlgames.com/CarromPool/",
    year: 2016,
    rating: 92,
    price: 12.96,
    originalPrice: 32.39,
    discount: "60%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/carrompool800450.webp",
    isFree: true,
    genres: "Classic",
    platform: "Web Browser",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 28,
    title: "Cube Block",
    genre: "Classic",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/cubeblock800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/F17vRDoLTvg?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=F17vRDoLTvg",
    embedLink: "https://cdn.htmlgames.com/CubeBlock/",
    year: 2020,
    rating: 27,
    price: 5.01,
    originalPrice: 25.05,
    discount: "80%",
    image: "https://www.htmlgames.com/uploaded/game/thumb800/cubeblock800450.webp",
    isFree: true,
    genres: "Classic",
    platform: "PC",
    publisher: "FunArcade",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 29,
    title: "Upside Down",
    genre: "Classic",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/upsidedown800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/Q9aAlbCF02U?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=Q9aAlbCF02U",
    embedLink: "https://cdn.htmlgames.com/UpsideDown/",
    year: 2017,
    rating: 73,
    price: 3.83,
    originalPrice: 38.29,
    discount: "90%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/upsidedown800450.webp",
    isFree: true,
    genres: "Classic",
    platform: "PC",
    publisher: "Skyplay",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 30,
    title: "Ninja Breakout",
    genre: "Classic",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/ninjabreakout800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/r-xSAJ603Oo?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=r-xSAJ603Oo",
    embedLink: "https://cdn.htmlgames.com/NinjaBreakout/",
    year: 2013,
    rating: 17,
    price: 16.4,
    originalPrice: 18.22,
    discount: "10%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/ninjabreakout800450.webp",
    isFree: true,
    genres: "Classic",
    platform: "Mobile",
    publisher: "FunArcade",
    players: "Single Player",
    isOnline: true,
  },

  // --- Hidden Object Games ---
  {
    id: 31,
    title: "Medieval Castle Hidden Differences",
    genre: "Hidden Objects",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/medievalcastlehiddendifferences800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/Oz9X_xXQSos?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=Oz9X_xXQSos",
    embedLink: "https://cdn.htmlgames.com/MedievalCastleHiddenDifferences/",
    year: 2009,
    rating: 67,
    price: 17.49,
    originalPrice: 34.98,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/medievalcastlehiddendifferences800450.webp",
    isFree: true,
    genres: "Hidden Objects",
    platform: "Web Browser",
    publisher: "FunArcade",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 32,
    title: "Treasure Maze",
    genre: "Hidden Objects",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/treasuremaze800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/VaH8G0sTJaY?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=VaH8G0sTJaY",
    embedLink: "https://cdn.htmlgames.com/TreasureMaze/",
    year: 2012,
    rating: 55,
    price: 16.75,
    originalPrice: 27.92,
    discount: "40%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/treasuremaze800450.webp",
    isFree: true,
    genres: "Hidden Objects",
    platform: "Mobile",
    publisher: "Playverse",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 33,
    title: "Street Hidden Objects",
    genre: "Hidden Objects",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/streethiddenobjects800480.webp",
    youtubePreview:
      "https://www.youtube.com/embed/BnAyZ8EGKGc?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=BnAyZ8EGKGc",
    embedLink: "https://cdn.htmlgames.com/StreetHiddenObjects/",
    year: 2003,
    rating: 70,
    price: 3.5,
    originalPrice: 17.48,
    discount: "80%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/streethiddenobjects800450.webp",
    isFree: true,
    genres: "Hidden Objects",
    platform: "All Platforms",
    publisher: "FunArcade",
    players: "Co-op",
    isOnline: true,
  },
  {
    id: 34,
    title: "Jewels Classic",
    genre: "Hidden Objects",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/jewelsclassic800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/7WvAIKhQvug?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=7WvAIKhQvug",
    embedLink: "https://cdn.htmlgames.com/JewelsClassic/",
    year: 2020,
    rating: 79,
    price: 18.91,
    originalPrice: 37.82,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/jewelsclassic800450.webp",
    isFree: true,
    genres: "Hidden Objects",
    platform: "All Platforms",
    publisher: "Skyplay",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 35,
    title: "Medieval Castle Defense",
    genre: "Hidden Objects",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/medievalcastledefense800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/AeHATqxExL0?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=AeHATqxExL0",
    embedLink: "https://cdn.htmlgames.com/MedievalCastleDefense/",
    year: 2003,
    rating: 31,
    price: 9.93,
    originalPrice: 19.85,
    discount: "50%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/medievalcastledefense800450.webp",
    isFree: true,
    genres: "Hidden Objects",
    platform: "PC",
    publisher: "Playverse",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 36,
    title: "Desert Oasis - Hidden Secrets",
    genre: "Action",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/desertoasis-hiddensecrets800450.webp",

    youtubePreview:
      "https://www.youtube.com/embed/VXjxnmS__gI?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=VXjxnmS__gI",
    embedLink: "https://cdn.htmlgames.com/DesertOasis-HiddenSecrets/",
    year: 2021,
    rating: 84,
    price: 3.99,
    originalPrice: 9.99,
    discount: "60%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/desertoasis-hiddensecrets-800450.webp",
    isFree: true,
    genres: "Action",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },
  {
    id: 333,
    title: "Wild West Mysteries",
    genre: "Action",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/wildwestmysteries800450.webp",

    youtubePreview:
      "https://www.youtube.com/embed/nPyF7z5VJDU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=nPyF7z5VJDU",
    embedLink: "https://cdn.htmlgames.com/WildWestMysteries/",
    year: 2021,
    rating: 81,
    price: 3.49,
    originalPrice: 8.99,
    discount: "61%",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/wildwestmysteries-800450.webp",
    isFree: true,
    genres: "Action",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Multiplayer",
    isOnline: true,
  },
  // --- Card (from JSON) ---
  {
    id: 38,
    title: "Klaverjassen",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/klaverjassen800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/7pxUbd70r-k?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=7pxUbd70r-k",
    embedLink: "https://cdn.htmlgames.com/Klaverjassen/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/klaverjassen800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 39,
    title: "Skip Cards",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/skipcards800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/0LJP_XAIs1w?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=0LJP_XAIs1w",
    embedLink: "https://cdn.htmlgames.com/SkipCards/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/skipcards800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 40,
    title: "Spite and Malice",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/spiteandmalice800450.webp",
    youtubePreview: "",
    embedLink: "https://cdn.htmlgames.com/SpiteAndMalice/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/spiteandmalice800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 41,
    title: "Spite and Malice Extreme",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/spiteandmaliceextreme800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/VQDSx9S1agQ?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=VQDSx9S1agQ",
    embedLink: "https://cdn.htmlgames.com/SpiteAndMaliceExtreme/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/spiteandmaliceextreme800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 42,
    title: "Hartenjagen",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/hartenjagen800450.webp",
    youtubePreview: "",
    embedLink: "https://cdn.htmlgames.com/Hartenjagen/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/hartenjagen800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 43,
    title: "Crazy Eights",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/crazyeights800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/8_UGCfgLQaU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=8_UGCfgLQaU",
    embedLink: "https://cdn.htmlgames.com/CrazyEights/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/crazyeights800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 44,
    title: "Mau Mau",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/maumau800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/cBPeu8nu2TM?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=cBPeu8nu2TM",
    embedLink: "https://cdn.htmlgames.com/MauMau/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/maumau800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 45,
    title: "Alhambra Solitaire",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/alhambrasolitaire800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/w6thTDqiADw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=w6thTDqiADw",
    embedLink: "https://cdn.htmlgames.com/AlhambraSolitaire/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/alhambrasolitaire800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 46,
    title: "Hearts",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/hearts800450.webp",
    youtubePreview: "",
    embedLink: "https://cdn.htmlgames.com/Hearts/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/hearts800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 47,
    title: "Thirty One",
    genre: "Card",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/thirtyone800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/fV4J7ozGJ6s?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=fV4J7ozGJ6s",
    embedLink: "https://cdn.htmlgames.com/ThirtyOne/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/thirtyone800450.webp",
    isFree: true,
    genres: "Card",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },

  // --- Retro Games (from JSON) ---
  {
    id: 48,
    title: "Gold Miner",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/goldminer800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/a58j94SMIqU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=a58j94SMIqU",
    embedLink: "https://cdn.htmlgames.com/GoldMiner/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/goldminer800450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 49,
    title: "Spaceship Landing",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/spaceshiplanding800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/yS9GTr4EsIQ?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=yS9GTr4EsIQ",
    embedLink: "https://cdn.htmlgames.com/SpaceshipLanding/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/spaceshiplanding800450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 50,
    title: "Robot Cross Road",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/robotcrossroad800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/rx5IHsZmYis?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=rx5IHsZmYis",
    embedLink: "https://cdn.htmlgames.com/RobotCrossRoad/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/robotcrossroad800450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 51,
    title: "Frog Jumper",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/frogjumper800450.webp",
    youtubePreview: "",
    embedLink: "https://cdn.htmlgames.com/FrogJumper/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/frogjumper800450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 52,
    title: "Alien Invaders 2",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/alieninvaders2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/vxqu_7UBo6Q?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=vxqu_7UBo6Q",
    embedLink: "https://cdn.htmlgames.com/AlienInvaders2/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/alieninvaders2800450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 53,
    title: "Alien Invaders",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/alieninvaders800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/prLcQ-CF0Dc?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=prLcQ-CF0Dc",
    embedLink: "https://cdn.htmlgames.com/AlienInvaders/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/alieninvaders800450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 54,
    title: "Coloring Mandalas",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/coloring-mandalas-800x450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/fMgmfjpY16M?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=fMgmfjpY16M",
    embedLink: "https://cdn.htmlgames.com/ColoringMandalas/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/coloring-mandalas-800x450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 55,
    title: "Bubble Trouble",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/bubbletrouble800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/nrscNA0-Kg8?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=nrscNA0-Kg8",
    embedLink: "https://cdn.htmlgames.com/BubbleTrouble/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/bubbletrouble800450.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 56,
    title: "Classic Frog",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/classicfrog800480.webp",
    youtubePreview:
      "https://www.youtube.com/embed/lH38VVyiZMI?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=lH38VVyiZMI",
    embedLink: "https://cdn.htmlgames.com/ClassicFrog/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/classicfrog800480.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 57,
    title: "Coloring for Kids",
    genre: "Retro",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/coloringforkids800.webp",
    youtubePreview:
      "https://www.youtube.com/embed/_JF4THudH8Y?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=_JF4THudH8Y",
    embedLink: "https://cdn.htmlgames.com/ColoringForKids/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/coloringforkids800.webp",
    isFree: true,
    genres: "Retro",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },

  // --- Board Games (from JSON) ---
  {
    id: 58,
    title: "All Threes Domino",
    genre: "Board",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/allthreesdomino800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/wPpmPzSEprw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=wPpmPzSEprw",
    embedLink:
      "https://cdn.htmlgames.com/AllThreesDomino/index.html?npa=npa",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/allthreesdomino800450.webp",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 59,
    title: "MineSweeper 2 Player",
    genre: "Board",
    thumbnail: "https://www.htmlgames.com/uploaded/game/thumb/minesweeper300x200.webp",
    youtubePreview: "https://www.youtube.com/embed/wPpmPzSEprw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=wPpmPzSEprw",
    embedLink: "https://cdn.htmlgames.com/Minesweeper2Player/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 60,
    title: "Battleships",
    genre: "Board",
    thumbnail: "https://www.htmlgames.com/uploaded/game/thumb/battleships300.webp",
    youtubePreview: "https://www.youtube.com/embed/wPpmPzSEprw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=wPpmPzSEprw",
    embedLink: "https://cdn.htmlgames.com/Battleships/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 61,
    title: "Xiangqi",
    genre: "Board",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/xiangqi800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/jgFFnyKCu-c?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=jgFFnyKCu-c",
    embedLink: "https://cdn.htmlgames.com/Xiangqi/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/xiangqi800450.webp",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 62,
    title: "Block Domino",
    genre: "Board",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/blockdomino800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/zjXArFmexIk?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=zjXArFmexIk",
    embedLink: "https://cdn.htmlgames.com/BlockDomino/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/blockdomino800450.webp",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 63,
    title: "Gomoku",
    genre: "Board",
    thumbnail: "https://www.htmlgames.com/uploaded/game/thumb/gomoku300.webp",
    youtubePreview: "https://www.youtube.com/embed/wPpmPzSEprw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=wPpmPzSEprw",
    embedLink: "https://cdn.htmlgames.com/Gomoku/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 64,
    title: "Reversi",
    genre: "Board",
    thumbnail: "https://www.htmlgames.com/uploaded/game/thumb/reversi300.webp",
    youtubePreview: "https://www.youtube.com/embed/wPpmPzSEprw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=wPpmPzSEprw",
    embedLink: "https://cdn.htmlgames.com/Reversi/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 65,
    title: "Classic Domino",
    genre: "Board",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/classicdomino800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/-ihvJNRrqvA?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=-ihvJNRrqvA",
    embedLink: "https://cdn.htmlgames.com/ClassicDomino/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/classicdomino800450.webp",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 66,
    title: "Dots and Boxes",
    genre: "Board",
    thumbnail: "https://www.htmlgames.com/uploaded/game/thumb/dotsandboxes300.webp",
    youtubePreview: "https://www.youtube.com/embed/wPpmPzSEprw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=wPpmPzSEprw",
    embedLink: "https://cdn.htmlgames.com/DotsAndBoxes/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 67,
    title: "Crack the code",
    genre: "Board",
    thumbnail: "https://www.htmlgames.com/uploaded/game/thumb/crackthecode300.webp",
    youtubePreview: "https://www.youtube.com/embed/wPpmPzSEprw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=wPpmPzSEprw",
    embedLink: "https://cdn.htmlgames.com/CrackTheCode/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "",
    isFree: true,
    genres: "Board",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },

  // --- Racing Games (from JSON) ---
  {
    id: 68,
    title: "Traffic Racer 2",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficracer2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/_d__rnvDw0g?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=_d__rnvDw0g",
    embedLink: "https://cdn.htmlgames.com/TrafficRacer2/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficracer2800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 69,
    title: "Traffic Racer",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficracer800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/I-2t6kSR24s?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=I-2t6kSR24s",
    embedLink: "https://cdn.htmlgames.com/TrafficRacer/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficracer800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 70,
    title: "Big Parking",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/bigparking800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/nJ3SqHzSYIU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=nJ3SqHzSYIU",
    embedLink: "https://cdn.htmlgames.com/BigParking/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/bigparking800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 71,
    title: "Red and Green 2",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/WAiml6iAPw8?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=WAiml6iAPw8",
    embedLink: "https://cdn.htmlgames.com/RedAndGreen2/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen2800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 72,
    title: "Monkey in Trouble",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/monkeyIntrouble800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/GFmUfek5TBQ?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=GFmUfek5TBQ",
    embedLink: "https://cdn.htmlgames.com/MonkeyInTrouble/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/monkeyIntrouble800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 73,
    title: "Traffic Control",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficcontrol800450.webp",
    youtubePreview: "",
    embedLink: "https://cdn.htmlgames.com/TrafficControl/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficcontrol800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 74,
    title: "Dutch Shuffleboard",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/dutchshuffleboard800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/V3fN_1DR6g0?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=V3fN_1DR6g0",
    embedLink: "https://cdn.htmlgames.com/DutchShuffleboard/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/dutchshuffleboard800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 75,
    title: "Cube Block",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/cubeblock800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/F17vRDoLTvg?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=F17vRDoLTvg",
    embedLink: "https://cdn.htmlgames.com/CubeBlock/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/cubeblock800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 76,
    title: "Fruit Collector",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/fruitcollector800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/68r0eBYVOTQ?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=68r0eBYVOTQ",
    embedLink: "https://cdn.htmlgames.com/FruitCollector/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/fruitcollector800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 77,
    title: "Color Catch",
    genre: "Racing",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/colorcatch800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/elYjv4Y5KII?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=elYjv4Y5KII",
    embedLink: "https://cdn.htmlgames.com/ColorCatch/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/colorcatch800450.webp",
    isFree: true,
    genres: "Racing",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },

  // --- Shooting & War Games (from JSON) ---
  {
    id: 78,
    title: "Soldier Attack 2",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/soldierattack2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/sJsC9gHG09c?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=sJsC9gHG09c",
    embedLink: "https://cdn.htmlgames.com/SoldierAttack2/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/soldierattack2800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 79,
    title: "Airport Sniper",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/airportsniper800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/ZQlmxL7hn54?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=ZQlmxL7hn54",
    embedLink: "https://cdn.htmlgames.com/AirportSniper//",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/airportsniper800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 80,
    title: "Galaxy Shooter",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/galaxyshooter800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/8sOmiGALuQA?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=8sOmiGALuQA",
    embedLink: "https://cdn.htmlgames.com/GalaxyShooter/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/galaxyshooter800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 81,
    title: "Soldier Attack 1",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/soldierattack1800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/C0vn_v5XHLA?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=C0vn_v5XHLA",
    embedLink: "https://cdn.htmlgames.com/SoldierAttack1/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/soldierattack1800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 82,
    title: "Bottle Shooter",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/bottleshooter800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/Wpk6XZW-X18?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=Wpk6XZW-X18",
    embedLink: "https://cdn.htmlgames.com/BottleShooter/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/bottleshooter800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 83,
    title: "Archer",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/archer800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/Hz6lGfys_Oo?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=Hz6lGfys_Oo",
    embedLink: "https://cdn.htmlgames.com/Archer/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/archer800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 84,
    title: "Archery Training",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/acherytraining800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/p3Gp0BdJn0w?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=p3Gp0BdJn0w",
    embedLink: "https://cdn.htmlgames.com/ArcheryTraining/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/acherytraining800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 85,
    title: "Ninja Darts",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/ninjadarts800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/CLmyk8ngFYU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=CLmyk8ngFYU",
    embedLink: "https://cdn.htmlgames.com/NinjaDarts/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/ninjadarts800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 86,
    title: "Circus Shooter",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/circusshooter800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/D6M-4cTM0gU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=D6M-4cTM0gU",
    embedLink: "https://cdn.htmlgames.com/CircusShooter/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/circusshooter800450.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 87,
    title: "Sword Hit",
    genre: "Shooting & War",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/swordhit800.webp",
    youtubePreview:
      "https://www.youtube.com/embed/J6iNgkHenNo?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=J6iNgkHenNo",
    embedLink: "https://cdn.htmlgames.com/SwordHit/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "https://www.htmlgames.com/uploaded/game/thumb800/swordhit800.webp",
    isFree: true,
    genres: "Shooting & War",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },

  // --- Golf Games (from JSON) ---
  {
    id: 88,
    title: "Maya Golf 2",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/FdzoNLlhqMc?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=FdzoNLlhqMc",
    embedLink: "https://cdn.htmlgames.com/MayaGolf2/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf2800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 89,
    title: "Maya Golf",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/r-17SAZxQuE?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=r-17SAZxQuE",
    embedLink: "https://cdn.htmlgames.com/MayaGolf/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 90,
    title: "Mini Golf",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/minigolf800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/3rpYw7ihLmE?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=3rpYw7ihLmE",
    embedLink: "https://cdn.htmlgames.com/MiniGolf/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/minigolf800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 91,
    title: "Dutch Shuffleboard",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/dutchshuffleboard800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/V3fN_1DR6g0?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=V3fN_1DR6g0",
    embedLink: "https://cdn.htmlgames.com/DutchShuffleboard/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/dutchshuffleboard800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 92,
    title: "Downhill",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/downhill800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/yEXv1TG8LI8?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=yEXv1TG8LI8",
    embedLink: "https://cdn.htmlgames.com/Downhill/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/downhill800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 93,
    title: "Tennis",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/tennis800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/9G_JKxuWe_o?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=9G_JKxuWe_o",
    embedLink: "https://cdn.htmlgames.com/Tennis/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/tennis800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 94,
    title: "Air Hockey",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/airhockey800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/GmTQ5mZJvKo?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=GmTQ5mZJvKo",
    embedLink: "https://cdn.htmlgames.com/AirHockey/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/airhockey800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 95,
    title: "Bowling",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/bowling800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/EAAwmtfsqQY?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=EAAwmtfsqQY",
    embedLink: "https://cdn.htmlgames.com/Bowling/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/bowling800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 96,
    title: "Basketball Legend",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/basketballlegend800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/SfTEpdG0qy4?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=SfTEpdG0qy4",
    embedLink: "https://cdn.htmlgames.com/BasketballLegend/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/basketballlegend800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 97,
    title: "Soccer Pinball",
    genre: "Golf",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/soccerpinball800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/LleWYcnO4GU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=LleWYcnO4GU",
    embedLink: "https://cdn.htmlgames.com/SoccerPinball/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/soccerpinball800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },

  // --- Sports Games (from JSON) ---
  {
    id: 98,
    title: "Dutch Shuffleboard",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/dutchshuffleboard800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/V3fN_1DR6g0?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=V3fN_1DR6g0",
    embedLink: "https://cdn.htmlgames.com/DutchShuffleboard/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/dutchshuffleboard800450.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 99,
    title: "Maya Golf 2",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/FdzoNLlhqMc?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=FdzoNLlhqMc",
    embedLink: "https://cdn.htmlgames.com/MayaGolf2/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf2800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 100,
    title: "Downhill",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/downhill800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/yEXv1TG8LI8?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=yEXv1TG8LI8",
    embedLink: "https://cdn.htmlgames.com/Downhill/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/downhill800450.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 101,
    title: "Tennis",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/tennis800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/9G_JKxuWe_o?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=9G_JKxuWe_o",
    embedLink: "https://cdn.htmlgames.com/Tennis/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/tennis800450.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 102,
    title: "Air Hockey",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/airhockey800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/GmTQ5mZJvKo?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=GmTQ5mZJvKo",
    embedLink: "https://cdn.htmlgames.com/AirHockey/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/airhockey800450.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 103,
    title: "Bowling",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/bowling800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/EAAwmtfsqQY?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=EAAwmtfsqQY",
    embedLink: "https://cdn.htmlgames.com/Bowling/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/bowling800450.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 104,
    title: "Basketball Legend",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/basketballlegend800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/SfTEpdG0qy4?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=SfTEpdG0qy4",
    embedLink: "https://cdn.htmlgames.com/BasketballLegend/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/basketballlegend800450.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 105,
    title: "Soccer Pinball",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/soccerpinball800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/LleWYcnO4GU?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=LleWYcnO4GU",
    embedLink: "https://cdn.htmlgames.com/SoccerPinball/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/soccerpinball800450.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 106,
    title: "Maya Golf",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/r-17SAZxQuE?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=r-17SAZxQuE",
    embedLink: "https://cdn.htmlgames.com/MayaGolf/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/mayagolf800450.webp",
    isFree: true,
    genres: "Golf",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 107,
    title: "Giant Slalom",
    genre: "Sports",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/giantslalom800.webp",
    youtubePreview:
      "https://www.youtube.com/embed/p-iOAyVQ5rw?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=p-iOAyVQ5rw",
    embedLink: "https://cdn.htmlgames.com/GiantSlalom/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/giantslalom800.webp",
    isFree: true,
    genres: "Sports",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },

  // --- Skill Games (from JSON) ---
  {
    id: 108,
    title: "Red and Green 2",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen2800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/WAiml6iAPw8?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=WAiml6iAPw8",
    embedLink: "https://cdn.htmlgames.com/RedAndGreen2/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen2800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 109,
    title: "Traffic Control",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficcontrol800450.webp",
    youtubePreview: "",
    embedLink: "https://cdn.htmlgames.com/TrafficControl/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/trafficcontrol800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 110,
    title: "Cube Block",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/cubeblock800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/F17vRDoLTvg?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=F17vRDoLTvg",
    embedLink: "https://cdn.htmlgames.com/CubeBlock/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/cubeblock800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 111,
    title: "Fruit Collector",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/fruitcollector800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/68r0eBYVOTQ?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=68r0eBYVOTQ",
    embedLink: "https://cdn.htmlgames.com/FruitCollector/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/fruitcollector800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 112,
    title: "Color Catch",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/colorcatch800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/elYjv4Y5KII?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=elYjv4Y5KII",
    embedLink: "https://cdn.htmlgames.com/ColorCatch/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/colorcatch800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 113,
    title: "Fishing Trip",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/fishingtrip800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/aBsbh7a43O4?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=aBsbh7a43O4",
    embedLink: "https://cdn.htmlgames.com/FishingTrip/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/fishingtrip800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 114,
    title: "Red and Green",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/aUS4LgOtb6Y?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=aUS4LgOtb6Y",
    embedLink: "https://cdn.htmlgames.com/RedAndGreen/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/redandgreen800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 115,
    title: "Happy Bird",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/happybird800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/ya8X8x7QL94?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=ya8X8x7QL94",
    embedLink: "https://cdn.htmlgames.com/HappyBird/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/happybird800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 116,
    title: "Zig Zag Gate",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/zigzaggate800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/7eGKHTekR7w?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=7eGKHTekR7w",
    embedLink: "https://cdn.htmlgames.com/ZigZagGate/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image:
      "https://www.htmlgames.com/uploaded/game/thumb800/zigzaggate800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
  {
    id: 117,
    title: "Drop",
    genre: "Skill",
    thumbnail:
      "https://www.htmlgames.com/uploaded/game/thumb800/drop800450.webp",
    youtubePreview:
      "https://www.youtube.com/embed/HEH4RpzWfws?controls=0&showinfo=0&autoplay=1&mute=1&loop=1&playlist=HEH4RpzWfws",
    embedLink: "https://cdn.htmlgames.com/Drop/",
    year: null,
    rating: null,
    price: null,
    originalPrice: null,
    discount: "",
    image: "https://www.htmlgames.com/uploaded/game/thumb800/drop800450.webp",
    isFree: true,
    genres: "Skill",
    platform: "All Platforms",
    publisher: "HTML Games Studio",
    players: "Single Player",
    isOnline: true,
  },
];
